<div *ngIf="showTimer" class="timer-container" [class.warning]="isWarning" (click)="onTimerClick()" [attr.role]="remainingTime <= 900 ? 'button' : null" [attr.tabindex]="remainingTime <= 900 ? '0' : null" (keydown.enter)="onTimerClick()" (keydown.space)="onTimerClick()">
  <svg class="timer-circle" viewBox="0 0 36 36">
    <path class="timer-circle-bg" d="M18 5 a 13 13 0 0 1 0 26 a 13 13 0 0 1 0 -26" />
    <path
      #progressPath
      class="timer-circle-progress"
      [class.warning]="isWarning"
      [style.stroke]="isWarning ? '#fc1317' : null"
      [style.stroke-dasharray]="circumference"
      [style.stroke-dashoffset]="strokeDashoffset"
      d="M18 5 a 13 13 0 0 1 0 26 a 13 13 0 0 1 0 -26"
    />
  </svg>
  <div class="timer-text" [class.warning]="isWarning">{{ formattedTime }}</div>
</div>